import { FormControlLabel, Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  label: {
    color: '#333',
    fontFamily: theme.custom.fonts.SFUITextRegular,
    fontSize: 16,
  },
  checkbox: ({ size = '1.5rem' }) => ({
    color: "#000",
    fontSize: size,
    '&.Mui-checked': {
      color: "#000",
    },
    '& .MuiSvgIcon-root': {
      fontSize: 'inherit',
    },
  }),
}));

const ExpCheckbox = (props) => {
  const classes = useStyles(props);

  return (
    <FormControlLabel
      control={
        <Checkbox
          {...props}
          classes={{ root: classes.checkbox }}
          color="default"
        />
      }
      label={props.label}
      classes={{ label: classes.label }}
    />
  );
};

export default ExpCheckbox;
